export default __webpack_public_path__ + "media/components/AppointmentScheduler/images/loader-60ad8f1275594db49eb2510af1a66e1d.png";